import React, { useState, useEffect } from 'react';
import { parseMinecraftText } from '../../utils/minecraftIcons';
import './MinecraftBlockCountdown.css';

function calculateTimeLeft(timestamp) {
  const now = Date.now();
  // Convert timestamp from seconds to milliseconds if needed
  const targetTime = timestamp < 10000000000 ? timestamp * 1000 : timestamp;
  const diff = Math.max(0, targetTime - now);

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);

  return { days, hours, minutes, seconds };
}

function formatTime({ days, hours, minutes, seconds }) {
  // Show only the three largest time units
  if (days > 0) {
    return `${days}d ${hours}h ${minutes}m`;
  } else if (hours > 0) {
    return `${hours}h ${minutes}m ${seconds}s`;
  } else if (minutes > 0) {
    return `${minutes}m ${seconds}s`;
  } else {
    return `${seconds}s`;
  }
}

function formatEventDate(timestamp) {
  const targetTime = timestamp < 10000000000 ? timestamp * 1000 : timestamp;
  const date = new Date(targetTime);
  return date.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

function getEventNameAndColor(name) {
  if (!name) return { cleanName: 'Next Event', color: '#F5B041' };

  const segments = parseMinecraftText(name);

  if (!Array.isArray(segments) || segments.length === 0) {
    return { cleanName: name, color: '#F5B041' };
  }

  // Get the clean name by joining all segment texts
  const cleanName = segments.map(seg => seg.text).join('');

  // Get the first color found in segments, or default to orange
  const color = segments.find(seg => seg.color)?.color || '#F5B041';

  return { cleanName, color };
}

export default function MinecraftBlockCountdown({ timestamp, eventName, onComplete }) {
  const [timeLeft, setTimeLeft] = useState(() => calculateTimeLeft(timestamp));

  useEffect(() => {
    const interval = setInterval(() => {
      const newTime = calculateTimeLeft(timestamp);
      setTimeLeft(newTime);

      if (newTime.days === 0 && newTime.hours === 0 && newTime.minutes === 0 && newTime.seconds === 0) {
        onComplete && onComplete();
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [timestamp, onComplete]);

  const { cleanName, color } = getEventNameAndColor(eventName);

  return (
    <div className="countdown-simple">
      <div className="countdown-header">
        <div className="countdown-event-name" style={{ color }}>{cleanName}</div>
        <div className="countdown-event-date">{formatEventDate(timestamp)}</div>
      </div>
      <div className="countdown-time">{formatTime(timeLeft)}</div>
    </div>
  );
}
